import { render, staticRenderFns } from "./DocVirtual.vue?vue&type=template&id=bf90b90a&"
import script from "./DocVirtual.vue?vue&type=script&lang=js&"
export * from "./DocVirtual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports